import { memo } from 'react'
import { colors } from '@pff-consumer/core-ui'
import { SVGGroup } from '@pff-consumer/utils'
import { Icon } from '../../atoms/icon'
import type { FormFieldProps } from './form-field.props'
import { Text, TextDescriptionVariant } from '../../atoms/text'
import { Label } from '../../atoms/label/label.web'
import { useStyles } from './form-field.web.styles'

export const FormField = memo((props: FormFieldProps) => {
  const {
    label,
    children,
    description,
    errorMessage,
    errorIcon = 'field-error',
    isRequired = false,
    containerStyles = '',
  } = props
  const styles = useStyles()

  return (
    <div
      className={`${styles.container} ${containerStyles}`}
      data-testid='formField'
    >
      {label && (
        <Label
          label={label}
          isRequired={isRequired}
        />
      )}
      {description && (
        <Text
          colorOverride={colors.webTextColorLight}
          variant={TextDescriptionVariant.TEXT_XS_REGULAR}
        >
          {description}
        </Text>
      )}
      <div className={styles.children}>{children}</div>
      <div className={styles.errorContainer}>
        {errorMessage && errorMessage?.trim() !== '' && (
          <>
            <Icon
              name={errorIcon}
              group={SVGGroup.Icons}
              width={12}
              height={12}
            />
            <Text
              colorOverride={colors.webErrorColor}
              variant={TextDescriptionVariant.TEXT_XS_REGULAR_ITALIC}
            >
              {errorMessage}
            </Text>
          </>
        )}
      </div>
    </div>
  )
})
